import _ from 'lodash';
import qs from 'qs';
import { axiosAPI } from '@/axios';

const defaultFilter = { status: 'any', sort: 'createdAt' };

const loadVideos = (filter) => {
  const query = qs.stringify(_.defaults(filter, defaultFilter), { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/videos${query}`);
  }
  return axiosAPI.get('/videos?status=any');
};

const loadVideoByKey = (videoId) => {
  return axiosAPI.get(`/videos/${videoId}?showEditor=any`);
};

const uploadVideo = (body) => {
  return axiosAPI.post('/videos', body);
};

const updateVideoByKey = (videoId, newVideo) => {
  return axiosAPI.put(`/videos/${videoId}`, newVideo);
};

const deleteVideo = (videoId) => {
  return axiosAPI.delete(`/videos/${videoId}`);
};

const uploadMultipleVideos = (body) => {
  return axiosAPI.post('/videos/batch-create', body);
};

const previewVideo = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  return axiosAPI.get(`/videos/preview${query}`);
};

const getUploadToken = () => {
  return axiosAPI.post('/integrations/byteark-qoder/accesses');
};

const loadTpbsVideos = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  return axiosAPI.get(`/import/videos${query}`);
};

const importVideos = (body) => {
  return axiosAPI.post('/import/videos', body);
};

// For Modals
const loadVideosByPage = (page) => {
  let url = '/videos?limit=5';
  if (page) {
    url += `&page=${page}`;
  }
  return axiosAPI.get(url);
};

const searchVideosInsideModal = (name) => {
  return axiosAPI.get(`/videos?limit=5&q=${name}`);
};

export {
  loadVideos,
  loadVideoByKey,
  updateVideoByKey,
  uploadVideo,
  deleteVideo,
  uploadMultipleVideos,
  previewVideo,
  getUploadToken,
  loadVideosByPage,
  searchVideosInsideModal,
  loadTpbsVideos,
  importVideos,
};
